import PropTypes from "prop-types";
import Layout from 'common/layout';
import NavigationContainer from 'sites/containers/modules/navigation';
import PageLoader from "common/components/modules/page-loading";
import PageHeaderContainer from 'sites/containers/modules/page-header';

const LayoutView = ({
   children,
   isSiteInited,
   isGlobalLoading,
   noNeedToInit,
   isHideMenu,
   isHideHeader,
}) => {

   const siteInited = noNeedToInit || isSiteInited

   return (
      <Layout>
         {
            !isHideMenu && siteInited && (
               <div
                  style={ {
                     zIndex: 3,
                  } }
               >
                  <Layout.Menu>
                     <NavigationContainer />
                  </Layout.Menu>
               </div>
            )
         }
         {
            (!siteInited || isGlobalLoading) && (
               <div className='w-full bg-[#F9FAFB] dark:bg-[#000000] absolute top-[56px] bottom-0 z-2'>
                  <div
                     className='w-full h-[calc(100vh-56px)] flex items-center justify-center'
                  >
                     <PageLoader
                        withLoader
                        loaderColor='primary'
                     />
                  </div>
               </div>
            )
         }

         {
            siteInited && (
               <div
                  className='w-full'
                  style={ {
                     zIndex: 1,
                  } }
               >
                  <Layout.Content>
                     {
                        !isHideHeader && (
                           <PageHeaderContainer />
                        )
                     }
                     {children}
                  </Layout.Content>
               </div>
            )
         }
      </Layout>
   )
}

LayoutView.propTypes = {
   children: PropTypes.any,
   isSiteInited: PropTypes.bool,
   isGlobalLoading: PropTypes.bool,
   noNeedToInit: PropTypes.bool,
   isHideMenu: PropTypes.bool,
   isHideHeader: PropTypes.bool,
}

export default LayoutView;
